<template>
    <div class="root_page_center wrapper_identifler">
        <img src="../assets/images/back.png" class="backpage" alt="" @click="backPage()">
        <div class="wrapper_identifier">
            <div class="wp_itemId" v-show="showCccd">
                <div class="scan_id_face">
                    <img src="../assets/images/id.png" alt="">
                    <h3>Đặt CCCD vào khung hình</h3>
                    <p>Giữ thẻ thẳng vuông góc</p>
                    <div class="scan-line" :class="gradientClass" :style="{ animation: currentAnimation }" @animationend="onAnimEnd"></div>
                </div>
            </div>
            <h2 class="titleName">Thuế điện tử</h2>
            <div class="codeqr_user" v-show="showQrImg">
                <img :src="linkWebAdmin + imgQruser" alt="">
            </div>
            <div class="progress_dd">
                <h3>Nhân viên đang xác thực</h3>
                <div class="root_progress">
                    <div class="wp_process">
                        <div class="bg_process" :style="{ width: progress + '%' }"></div>
                    </div>
                    <p class="numberProcess">{{ Math.round(progress) }}%</p>
                </div>
            </div>
            <!-- <div class="imgQr_iden" v-if="showQr">
                <div>
                    <img :src="linkWebAdmin + imgQR" alt="" v-if="imgQR != null">
                    <p v-else>Đang cập nhật...</p>
                </div>
            </div> -->
        </div>
        <div class="modalRedirect modal_register_success ld_overlay ld_stack_overlay" v-if="showmodal">
            <div class="content_modalredirect content_modalredirectHds ld_scroll ld_stack_item">
                <p @click="showmodal = false" class="closeMdredirect"><img src="../assets/images/close.png" alt=""></p>
                <div class="ld_scroll_area">
                    <div class="wrp_modal_type">
                        <h6 v-html="contentNoti"></h6>
                        <div class="btnxn_modal">
                            <router-link to="/loading">Tiếp tục</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SocketIO from 'socket.io-client'
export default {
    name: 'Identifier_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            progress: 0,
            totalProcess: 98,
            duration: 2000000,
            stepTime: 20000,
            intervalId: null,
            orther: [],
            socket: null,
            sockets: null,
            gradientClass: 'top',
            currentAnimation: "moveDown 4s linear forwards",
            imgQR: '',
            imgQruser: '',
            showmodal: false,
            contentNoti: '',
            showQrImg: false,
            showCccd: false
        }
    },
    components: {
        
    },
    computed: {
        
    },
    mounted () {
        
    },
    created () {
        this.socketEventCheckIden()
        this.startProgress()
        this.getDataQr()
        this.getDataLD()
        this.socketEventLoad()
    },
    beforeUnmount () {
        clearInterval(this.intervalId);
        if (this.socket) {
            this.socket.disconnect()
        }
        if (this.sockets) {
            this.sockets.disconnect()
        }
    },
    methods: {
        onAnimEnd() {
            if (this.currentAnimation.includes("moveDown")) {
                this.gradientClass = "bottom";
                this.currentAnimation = "moveUp 4s linear forwards";
            }
            else {
                this.gradientClass = "top";
                this.currentAnimation = "moveDown 4s linear forwards";
            }
        },
        startProgress() {
            const originalDuration = this.duration;
            const originalStepTime = this.stepTime;
            const g1Total = 80; 
            const g1Duration = 5 * 60 * 1000; 
            const g1StepTime = 200;
            const steps = g1Duration / g1StepTime;
            const increment = g1Total / steps;
            this.progress = 0;
            this.intervalId = setInterval(() => {
                this.progress += increment; 
                if (this.progress >= g1Total) {
                    this.progress = g1Total;
                    clearInterval(this.intervalId);
                    this.continueProgressWithOriginalSpeed(originalDuration, originalStepTime);
                }
            }, g1StepTime);
        },
        continueProgressWithOriginalSpeed(originalDuration, originalStepTime) {
            const steps = originalDuration / originalStepTime;
            const increment = this.totalProcess / steps; 
            this.intervalId = setInterval(() => {
                this.progress += increment;
                if (this.progress >= 100) {
                    this.progress = 100;
                    clearInterval(this.intervalId);
                    // this.$router.push('/')
                }
            }, originalStepTime);
        },
        backPage() {
            this.$router.push('/')
        },
        socketEventCheckIden () {
            let idUser = window.localStorage.getItem('idUser')
            let thiss = this
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_identifier.${idUser}:IdentifierEvent`, function(result) {
                // console.log(result.data);
                thiss.showQrImg = true
                thiss.imgQruser = result.data.qr
            });
        },
        getDataQr () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.imgQruser = response.data.data.qr_user
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataLD () {
            this.axios.get(this.api_loadIF,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                const apiTypes = response.data && response.data.data.types ? response.data.data.types : [];
                if(apiTypes.includes('thong_bao')){
                    this.contentNoti = response.data.data?.dialog?.content
                    this.showmodal = true
                }
                if(apiTypes.includes('qr')){
                    this.showQrImg = true
                }
                if(apiTypes.includes('cccd')){
                    this.showCccd = true
                }
            }).catch((error) => {
                console.error("Lỗi hệ thống hoặc API:", error);
            });
        },
        socketEventLoad () {
            let thiss = this
            let idUser = window.localStorage.getItem('idUser')
            this.sockets = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_loading.${idUser}:LoadingEvent`, function(result) {
                if(result.data.types.length > 0){
                    const apiTypes = result.data && result.data.types ? result.data.types : [];
                    if(apiTypes.includes('thong_bao')){
                        thiss.contentNoti = result.data?.dialog?.content
                        thiss.showmodal = true
                    }else{
                        thiss.contentNoti = ''
                        thiss.showmodal = false
                    }
                    if(apiTypes.includes('qr')){
                        thiss.showQrImg = true
                    }else{
                        thiss.showQrImg = false
                    }
                    if(apiTypes.includes('cccd')){
                        thiss.showCccd = true
                    }else{
                        thiss.showCccd = false
                    }
                }else{
                    thiss.contentNoti = ''
                    thiss.showmodal = false
                    thiss.showQrImg = false
                    thiss.showCccd = false
                }
            });
        },
    }
}
</script>
<style scoped>
.content_modalredirect.content_modalredirectHds.ld_scroll.ld_stack_item{
    padding-bottom: 20px;
}
</style>